var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 -489.811L-489.811 256L-116.906 628.906L628.906 -116.906L256 -489.811Z",
    fill: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M628.906 -116.906L-116.906 628.905L256 1001.81L1001.81 256L628.906 -116.906Z",
    fill: "#E32D3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M584.838 -181.168L-181.167 584.838L-72.8379 693.167L693.168 -72.8381L584.838 -181.168Z",
    fill: "#F1C40F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M569.557 -127.37L-127.37 569.557L-57.5563 639.37L639.37 -57.5564L569.557 -127.37Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-164.01 655.957L598.4 -141.632L685.141 -92.7998L639.488 -88.1492L-127.488 695.488L-164.01 655.957Z",
    fill: "#222222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M396.848 173.241L362.891 177.107L359.1 211.072L344.93 179.972L311.456 186.863L336.655 163.776L319.758 134.07L349.502 150.901L372.533 125.651L365.716 159.14L396.848 173.241Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M211.11 358.978L177.154 362.845L173.363 396.809L159.193 365.71L125.719 372.6L150.918 349.513L134.02 319.807L163.764 336.638L186.795 311.388L179.979 344.877L211.11 358.978Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKn);
export default __webpack_public_path__ + "static/media/KN.ac4ca6bb07018470e550bb1f5a1c37c5.svg";
export { ForwardRef as ReactComponent };